import React from 'react';

export default function ChapterContent({ chapter, isUnlocked }) {
  return (
    <div 
      className={`chapter-card rounded shadow ${isUnlocked ? 'bg-light' : 'locked-chapter'}`}
      style={{ backgroundImage: `url(https://diadelavida.com/images/numbers/${chapter.order}.png)` }}
      >
        <div className="d-flex justify-content-between align-items-center w-100">
          <h3 className="mb-0">{chapter.title}</h3>
          {!isUnlocked && (
            <span className="badge bg-dark mb-2">Bloqueado</span>
          )}
        </div>
      
      {isUnlocked ? (
        <div>
          <p>{chapter.content}</p>
        </div>
      ) : (
        <div className="">
          {chapter.requiredUrlText}
        </div>
      )}
    </div>
  );
}